export default __webpack_public_path__ + "static/media/image-chair-algo-d-2-w.c481f152.png";